module.exports = __webpack_public_path__ + "static/media/Ryad.fb7f5052.jpg";